import React, { useState, useEffect } from "react";
import { FaPlus } from "react-icons/fa";
import Spinner from "../../Component/Spinner/Spinner";
import axios from "axios";
import { Api } from "../../BackendApi/api";
import { useNavigate } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import "../MobileCustomer/MobileCustomerList.css";
import { formatIndianDate } from "../../Component/IndFormatDate/formatIndianDate";
import MobileCustomerHeader from "./MobileCustomerHeader/MobileCustomerHeader";
import MobileConfirmPopup from "../../Component/MobileConfirmPopup/MobileConfirmPopup";
import {
  FaUser,
  FaPhoneAlt,
  FaCoins,
  FaUserShield,
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaExchangeAlt,
} from "react-icons/fa";
import EditMobileCustomerOverlay from "./EditMobileCustomerOverlay/EditMobileCustomerOverlay";
import MobileCustomerOverlay from "./MobileCustomerOverlay";

const columnToApiMap = {
  customerName: "CustName",
  mobile: "CustMobile",
  coins: "CustCurrentCoins",
  createdBy: "CreatedByAdminName",
  status: "Status",
  companyName: "CompName",
  lastLogin: "LastLogin",
  lastTransaction: "LastTransaction",
  reference: "Reference",
  address: "CustAddress",
  mapLocation: "CustLocation",
  createdAt: "CreatedAt",
};

const MobileCustomerList = () => {
  const navigate = useNavigate();
  const [globalSearch, setGlobalSearch] = useState("");
  const [columnSearch, setColumnSearch] = useState({
    customerName: "",
    mobile: "",
    coins: "",
    createdBy: "",
    status: "active",
    companyName: "",
    lastLoginStartDate: null,
    lastLoginEndDate: null,
    lastTransactionStartDate: null,
    lastTransactionEndDate: null,
    lastLogin: "",
    lastTransaction: "",
    reference: "",
    address: "",
    mapLocation: "",
  });
  const [sortState, setSortState] = useState({
    column: "lastTransaction",
    order: "desc",
  });
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showEditOverlay, setShowEditOverlay] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [showAddOverlay, setShowAddOverlay] = useState(false);
  const [popup, setPopup] = useState({
    show: false,
    message: "",
    type: "success",
  });

  const limit = 20;

  const handleSortChange = (column, order) => {
    setSortState({ column, order });
    setData([]);
    setPage(1);
    setHasMore(true);
  };

  const fetchCustomers = async (pageNum = 1, currentSortState = sortState) => {
    setLoading(true);
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        navigate("/");
        return;
      }

      const startfrom = (pageNum - 1) * limit;
      const apiSortColumn =
        columnToApiMap[currentSortState.column] || "LastTransaction";
      const apiSortOrder = currentSortState.order === "asc" ? 1 : -1;

      const payload = {
        searchstring: globalSearch || "",
        custName: columnSearch.customerName || "",
        custMobile: columnSearch.mobile || "",
        custCoins: columnSearch.coins || "",
        custStatus:
          columnSearch.status === "active"
            ? "ACTIVE"
            : columnSearch.status === "deactive"
            ? "DEACTIVE"
            : "",
        companyName: columnSearch.companyName || "",
        createdBy: columnSearch.createdBy || "",
        reference: columnSearch.reference || "",
        custAddress: columnSearch.address || "",
        custLocation: columnSearch.mapLocation || "",
        startfrom,
        limit,
        SortColumn: apiSortColumn,
        SortOrder: apiSortOrder,
      };

      const response = await axios.post(Api.getCustomers, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const customerArray = response.data.data || response.data.customers || [];

      let customers = customerArray.map((item, index) => ({
        id: item._id,
        Sr: startfrom + index + 1,
        customerName: item.CustName || "N/A",
        mobile: item.CustMobile || "N/A",
        coins: item.CustCurrentCoins ?? 0,
        createdBy: item.CreatedByAdminName || "Admin",
        status: item.Status || "DEACTIVE",
        companyName: item.CompName || "N/A",
        lastLogin: item.LastLogin ? formatIndianDate(item.LastLogin) : "-",
        lastTransaction: item.LastTransaction
          ? formatIndianDate(item.LastTransaction)
          : "-",
        reference: item.Reference || "-",
        address: item.CustAddress || "-",
        mapLocation: item.CustLocation,
      }));

      setData((prev) => (pageNum === 1 ? customers : [...prev, ...customers]));
      if (customers.length < limit) setHasMore(false);
    } catch (err) {
      setPopup({
        show: true,
        message: err.response?.data?.message || "Failed to fetch customers.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setData([]);
    setPage(1);
    setHasMore(true);
    const handler = setTimeout(() => {
      fetchCustomers(1);
    }, 300);
    return () => clearTimeout(handler);
  }, [globalSearch, columnSearch, sortState]);

  const fetchMoreData = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchCustomers(nextPage, sortState);
  };

  const handleEditClick = (customer) => {
    setSelectedCustomer(customer);
    setShowEditOverlay(true);
  };

  const handleCloseOverlay = () => {
    setShowEditOverlay(false);
    setSelectedCustomer(null);
  };

  const handlePopupClose = () => {
    setPopup({ ...popup, show: false });
  };

  return (
      <>
          <div
              className={`mobile-main-wrapper ${
                  showEditOverlay || showAddOverlay ? "blurred" : ""
              }`}
          >
              <div className="mobile-table-container">
                  <MobileCustomerHeader
                      search={globalSearch}
                      setSearch={setGlobalSearch}
                      columnSearch={columnSearch}
                      setColumnSearch={setColumnSearch}
                      onRefresh={() => {
                          setSortState({
                              column: "lastTransaction",
                              order: "desc",
                          });
                          setData([]);
                          setPage(1);
                          setHasMore(true);
                          fetchCustomers(1);
                      }}
                      sortColumn={sortState.column}
                      sortOrder={sortState.order}
                      onSortChange={handleSortChange}
                  />

                  <div className="mobile-grid-table" id="mobilescrollableDiv">
                      {loading && page === 1 ? (
                          <Spinner />
                      ) : data.length > 0 ? (
                          <InfiniteScroll
                              dataLength={data.length}
                              next={fetchMoreData}
                              hasMore={hasMore}
                              loader={<Spinner />}
                              endMessage={
                                  <div className="mobile-no-data">
                                      No more customers
                                  </div>
                              }
                              scrollableTarget="mobilescrollableDiv"
                              style={{ overflow: "visible" }}
                          >
                              {data.map((row) => (
                                  <div
                                      className={`mobile-grid-row ${
                                          row.status === "ACTIVE"
                                              ? "active"
                                              : "deactive"
                                      }`}
                                      key={row.Sr}
                                      onClick={() => handleEditClick(row)}
                                      style={{ cursor: "pointer" }}
                                  >
                                      <div className="mobile-header-row">
                                          <div
                                              className="mobile-customer-mobile"
                                              style={{ fontWeight: "bold" }}
                                          >
                                              <FaUser className="mobile-cust-icon" />{" "}
                                              {row.customerName}
                                          </div>

                                          <div className="mobile-coins-badge">
                                              <FaCoins className="coin-icon" />{" "}
                                              {row.coins}
                                          </div>
                                      </div>

                                      <div className="mobile-phone">
                                          <FaPhoneAlt
                                              className="mobile-cust-icon phone-icon"
                                              onClick={(e) => {
                                                  e.preventDefault();
                                                  e.stopPropagation();
                                                  if (
                                                      row.mobile &&
                                                      row.mobile !== "N/A"
                                                  ) {
                                                      window.location.href = `tel:${row.mobile}`;
                                                  } else {
                                                      alert(
                                                          "Phone number not available",
                                                      );
                                                  }
                                              }}
                                              style={{ cursor: "pointer" }}
                                          />
                                          {row.mobile}
                                      </div>

                                      <div className="mobile-address-cell">
                                          {row.mapLocation && (
                                              <FaMapMarkerAlt
                                                  className="mobile-cust-icon phone-icon"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={(e) => {
                                                      e.preventDefault();
                                                      e.stopPropagation();
                                                      const googleMapUrl = `https://www.google.com/maps?q=${row.mapLocation?.lat},${row.mapLocation?.lng}`;
                                                      window.open(
                                                          googleMapUrl,
                                                          "_blank",
                                                      );
                                                  }}
                                              />
                                          )}
                                          {row.address}
                                      </div>

                                      <div className="date-info-mobile">
                                          <FaCalendarAlt className="mobile-cust-icon" />
                                          <span
                                              style={{
                                                  color: "grey",
                                                  fontWeight: "500",
                                              }}
                                          >
                                              {row.lastLogin}
                                          </span>
                                      </div>

                                      <div className="date-info-mobile">
                                          <FaExchangeAlt className="mobile-cust-icon" />{" "}
                                          <span
                                              style={{
                                                  color: "grey",
                                                  fontWeight: "500",
                                              }}
                                          >
                                              {row.lastTransaction}
                                          </span>
                                      </div>
                                  </div>
                              ))}
                          </InfiniteScroll>
                      ) : (
                          <div className="mobile-no-data">
                              {loading
                                  ? "Searching customers..."
                                  : "No customers found"}
                          </div>
                      )}
                  </div>

                  {!showAddOverlay && (
                      <button
                          className="floating-add-btn"
                          onClick={() => setShowAddOverlay(true)}
                      >
                          <FaPlus />
                      </button>
                  )}
              </div>
          </div>

          {showEditOverlay && selectedCustomer && (
              <EditMobileCustomerOverlay
                  customer={selectedCustomer}
                  onClose={handleCloseOverlay}
                  onSave={() => {
                      handleCloseOverlay();
                      setData([]);
                      setPage(1);
                      fetchCustomers(1);
                  }}
              />
          )}

          {showAddOverlay && (
              <MobileCustomerOverlay
                  onClose={() => setShowAddOverlay(false)}
                  onSave={() => {
                      setShowAddOverlay(false);
                      setData([]);
                      setPage(1);
                      fetchCustomers(1);
                  }}
              />
          )}

          <MobileConfirmPopup
              show={popup.show}
              message={popup.message}
              type={popup.type}
              onClose={handlePopupClose}
          />
      </>
  );
};

export default MobileCustomerList;
